module.exports = __webpack_public_path__ + "img/hair_back_male_long_mask.b9ff7b89.png";